import { gate } from 'hub-http/gates';
export const FDSR_USE_BATCH_PROMISE = gate('FDSR:UseBatchPromise');